import { useSelector } from "react-redux";
import { can } from "../utils/moduleAccess";

/**
 * CRUD flags for a module from stored moduleAccess / permissions.
 * @param {string} moduleKey - e.g. "rfq", "ecatalogue", "user_management"
 */
export default function useModuleAccess(moduleKey) {
  const user = useSelector((state) => state.user);

  return {
    user,
    canView: can(user, moduleKey, "view"),
    canCreate: can(user, moduleKey, "create"),
    canUpdate: can(user, moduleKey, "update"),
    canDelete: can(user, moduleKey, "delete"),
  };
}
